module.exports = __webpack_public_path__ + "static/media/disc_conflict_sl_active.a481fb9c.png";